import { Form, Formik } from "formik";
import { Card, CardBody, FormGroup, Input, Label } from 'reactstrap';

const ContactDetails = ({ data, changeHandler, errorField }) => {
    const defaultValues = {
        vSchoolName: data?.detailList?.vSchoolName ?? '',
        vVisitorphone: data?.detailList?.vVisitorphone ?? '',
        vBrinnummer: data?.detailList?.vBrinnummer ?? '',
        vWebsite: data?.detailList?.vWebsite ?? '',
    };
    
    return (
        <Card className="main-card">
            <CardBody className="d-flex flex-column">
                <h5 className="mb-4">Contactgegevens</h5>
                <Formik
                    enableReinitialize
                    initialValues={defaultValues}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <FormGroup className={`form-element ${errorField === 'vSchoolName' ? 'error' : ''}`}>
                                <Label for="vSchoolName">Schoolnaam</Label>
                                <Input
                                    name="vSchoolName"
                                    type="text"
                                    value={values.vSchoolName}
                                    onChange={(e) => {
                                        handleChange(e);
                                        changeHandler('vSchoolName', e.target.value);
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className={`form-element ${errorField === 'vVisitorphone' ? 'error' : ''}`}>
                                <Label for="vVisitorphone">Telefoon</Label>
                                <Input
                                    name="vVisitorphone"
                                    type="text"
                                    value={values.vVisitorphone}
                                    onChange={(e) => {
                                        handleChange(e);
                                        changeHandler('vVisitorphone', e.target.value);
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className={`form-element ${errorField === 'vBrinnummer' ? 'error' : ''}`}>
                                <Label for="vBrinnummer">Brinnummer</Label>
                                <Input
                                    name="vBrinnummer"
                                    type="text"
                                    value={values.vBrinnummer}
                                    onChange={(e) => {
                                        handleChange(e);
                                        changeHandler('vBrinnummer', e.target.value);
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className={`form-element ${errorField === 'vWebsite' ? 'error' : ''}`}>
                                <Label for="vWebsite">Webpagina</Label>
                                <Input
                                    name="vWebsite"
                                    type="text"
                                    value={values.vWebsite}
                                    onChange={(e) => {
                                        handleChange(e);
                                        changeHandler('vWebsite', e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Form>
                    )}
                </Formik>
            </CardBody>
        </Card>
    );
};

export default ContactDetails;
